<template>
  <i class="cu-icon-interest" :class="{ 'on' : on }"></i>
</template>
<script>
export default {
  props: {
    on: {
      type: Boolean,
      default: false
    }
  }
}
</script>
